(function () {
  'use strict';

  var braceletStackImage = 'https://cdn.shopify.com/s/files/1/0763/4449/2338/files/bracelet_stack.webp?v=1784036734';
  var braceletStackUrl = '/collections/mens-bracelets?view=bracelet-stack&edit=1';

  function localCartCurrency(cart) {
    var stack = document.querySelector('[data-bracelet-stack][data-stack-presentment-currency][data-stack-presentment-rate]');
    var stackCurrency = stack?.dataset.stackPresentmentCurrency;
    var stackRate = Number(stack?.dataset.stackPresentmentRate);
    var stackDecimals = Number(stack?.dataset.stackPresentmentDecimals || 2);
    if (stackCurrency && stackRate) return { currency: stackCurrency, rate: stackRate, decimals: stackDecimals };

    var text = document.querySelector('.kaching-cart__checkout-button')?.textContent || '';
    var amount = text.match(/\d[\d.,]*/)?.[0];
    var currency = text.match(/\d[\d.,]*\s*([A-Z]{3})\s*$/)?.[1];
    var decimals = text.match(/[.,](\d+)(?:\s*[A-Z]{3})?\s*$/)?.[1].length || 0;
    var localCents = amount ? Number(amount.replace(/\D/g, '')) * 10 ** (2 - decimals) : 0;
    if (!currency || !cart.total_price || !localCents) {
      return null;
    }
    return { currency: currency, rate: localCents / cart.total_price, decimals: decimals };
  }

  function money(cents, local) {
    var currency = local?.currency || window.Shopify && Shopify.currency && Shopify.currency.active || 'USD';
    var rate = local?.rate || Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var decimals = local?.decimals ?? 2;
    var amount = (Number(cents) || 0) * rate / 100;
    try {
      var formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: currency, currencyDisplay: currency === 'USD' ? 'symbol' : 'code', minimumFractionDigits: decimals, maximumFractionDigits: decimals
      }).format(amount);
      return currency === 'USD' ? formatted : formatted.replace(currency, '').trim() + ' ' + currency;
    } catch (error) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  function groupRows() {
    document.querySelectorAll('[data-bracelet-stack-line="true"]').forEach(function (row) {
      row.hidden = false;
      row.removeAttribute('aria-hidden');
      row.classList.remove('bracelet-stack-group-row');
    });

    document.querySelectorAll('[data-bracelet-stack-grouped="true"]').forEach(function (row) {
      row.removeAttribute('data-bracelet-stack-grouped');
      var panel = row.querySelector('[data-bracelet-stack-panel]');
      if (panel) panel.remove();
    });

    var rows = Array.from(document.querySelectorAll('[data-bracelet-stack-line="true"]'));
    if (!rows.length) return;

    var first = rows[0];
    var total = rows.reduce(function (sum, row) { return sum + (Number(row.dataset.linePrice) || 0); }, 0);
    var count = rows.reduce(function (sum, row) { return sum + (Number(row.dataset.lineQuantity) || 0); }, 0);
    var details = first.querySelector('.cart-item__details');
    var totals = first.querySelector('.cart-item__totals');
    if (!details || !totals) return;

    details.innerHTML = '';
    var panel = document.createElement('div');
    panel.dataset.braceletStackPanel = 'true';
    panel.innerHTML = '<div class="bracelet-stack-group__heading"><a class="bracelet-stack-group__name" href="/collections/mens-bracelets?view=bracelet-stack&edit=1">Bracelet Stack</a><button type="button" class="bracelet-stack-group__remove" data-bracelet-stack-remove aria-label="Remove Bracelet Stack">×</button></div>'
      + '<button type="button" class="bracelet-stack-group__toggle" data-bracelet-stack-toggle aria-expanded="true"><span data-bracelet-stack-toggle-label>Hide ' + count + ' items</span><span class="bracelet-stack-group__chevron" aria-hidden="true">⌃</span></button>'
      + '<div class="bracelet-stack-group__items" data-bracelet-stack-items></div>';
    details.appendChild(panel);

    var itemList = panel.querySelector('[data-bracelet-stack-items]');
    rows.forEach(function (row) {
      var item = document.createElement('div');
      item.className = 'bracelet-stack-group__item';
      if (row.dataset.lineImage) {
        var image = document.createElement('img');
        image.className = 'bracelet-stack-group__item-image';
        image.src = row.dataset.lineImage;
        image.alt = '';
        item.appendChild(image);
      } else {
        var placeholder = document.createElement('span');
        placeholder.className = 'bracelet-stack-group__item-image';
        item.appendChild(placeholder);
      }
      var info = document.createElement('div');
      var name = document.createElement('span');
      name.className = 'bracelet-stack-group__item-name';
      name.textContent = row.dataset.lineTitle;
      info.appendChild(name);
      if (row.dataset.lineVariant && row.dataset.lineVariant !== 'Default Title') {
        var variant = document.createElement('span');
        variant.className = 'bracelet-stack-group__item-variant';
        variant.textContent = row.dataset.lineVariant;
        info.appendChild(variant);
      }
      item.appendChild(info);
      itemList.appendChild(item);
    });

    totals.querySelectorAll('.cart-item__price-wrapper').forEach(function (price) { price.innerHTML = '<span class="price price--end">' + money(total) + '</span>'; });
    first.classList.add('bracelet-stack-group-row');
    first.dataset.braceletStackGrouped = 'true';
    rows.slice(1).forEach(function (row) {
      row.hidden = true;
      row.setAttribute('aria-hidden', 'true');
    });
  }

  var kachingRequestAt = 0;
  var kachingRequest = null;

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function readKachingCart() {
    if (kachingRequest && Date.now() - kachingRequestAt < 1200) return kachingRequest;
    kachingRequestAt = Date.now();
    kachingRequest = fetch(cartRoot() + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) { return response.json(); })
      .catch(function () { return null; });
    return kachingRequest;
  }

  function restoreKaching() {
    document.querySelectorAll('.kaching-cart__checkout-button[data-bracelet-stack-kaching-checkout]').forEach(function (button) {
      var label = button.querySelector('.kaching-cart__checkout-button-label b');
      if (label) label.innerHTML = button.dataset.braceletStackKachingCheckout;
      delete button.dataset.braceletStackKachingCheckout;
    });
    document.querySelectorAll('[data-bracelet-stack-kaching-panel]').forEach(function (panel) { panel.remove(); });
    document.querySelectorAll('[data-bracelet-stack-kaching-hidden="true"]').forEach(function (row) {
      row.style.display = row.dataset.braceletStackKachingDisplay || '';
      row.removeAttribute('aria-hidden');
      row.removeAttribute('data-bracelet-stack-kaching-hidden');
      delete row.dataset.braceletStackKachingDisplay;
    });
    document.querySelectorAll('[data-bracelet-stack-kaching-enhanced="true"]').forEach(function (row) {
      var title = row.querySelector('.kaching-cart-item__title');
      var price = row.querySelector('.kaching-cart-item__total');
      var image = row.querySelector('.kaching-cart-item__image');
      var imageLink = image && image.closest('a');
      var remove = row.querySelector('[data-bracelet-stack-kaching-remove]');
      if (title && row.dataset.braceletStackKachingTitle !== undefined) title.innerHTML = row.dataset.braceletStackKachingTitle;
      if (price && row.dataset.braceletStackKachingPrice !== undefined) price.innerHTML = row.dataset.braceletStackKachingPrice;
      if (image && row.dataset.braceletStackKachingImage !== undefined) image.src = row.dataset.braceletStackKachingImage;
      if (image && row.dataset.braceletStackKachingSrcset) image.srcset = row.dataset.braceletStackKachingSrcset;
      if (imageLink && row.dataset.braceletStackKachingImageHref !== undefined) imageLink.href = row.dataset.braceletStackKachingImageHref;
      if (remove) remove.removeAttribute('data-bracelet-stack-kaching-remove');
      row.removeAttribute('data-bracelet-stack-kaching-enhanced');
      delete row.dataset.braceletStackKachingTitle;
      delete row.dataset.braceletStackKachingPrice;
      delete row.dataset.braceletStackKachingImage;
      delete row.dataset.braceletStackKachingSrcset;
      delete row.dataset.braceletStackKachingImageHref;
    });
  }

  function toggleKachingPanel(toggle) {
    var items = toggle.parentElement.querySelector('[data-bracelet-stack-kaching-items]');
    if (!items) return;
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    items.hidden = expanded;
    toggle.querySelector('[data-bracelet-stack-kaching-toggle-label]').textContent = (expanded ? 'Show ' : 'Hide ') + items.children.length + ' items';
  }

  function groupKachingCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var items = cart.items.filter(function (item) {
      return item.properties && String(item.properties._bracelet_stack).toLowerCase() === 'true';
    });
    if (!items.length) {
      restoreKaching();
      return;
    }

    var rows = Array.from(document.querySelectorAll('.kaching-cart-item[data-product-id]')).filter(function (row) {
      return !row.closest('[data-bracelet-stack-kaching-panel]');
    });
    var rowByProduct = {};
    var rowByVariant = {};
    rows.forEach(function (row) {
      var productId = row.dataset.productId;
      if (productId && !rowByProduct[productId]) rowByProduct[productId] = row;
      var variantId = row.dataset.variantId || row.getAttribute('data-variant-id');
      if (variantId && !rowByVariant[variantId]) rowByVariant[variantId] = row;
    });
    var matched = items.map(function (item) {
      return rowByProduct[String(item.product_id)] || rowByVariant[String(item.variant_id)];
    }).filter(Boolean);
    if (matched.length !== items.length) return;

    var linePrice = function (item) { return Number(item.final_line_price) || 0; };
    var originalTotal = items.reduce(function (sum, item) { return sum + (Number(item.original_line_price) || 0); }, 0);
    var itemCount = items.reduce(function (sum, item) { return sum + (Number(item.quantity) || 0); }, 0);
    var stackRoot = document.querySelector('[data-bracelet-stack]');
    var middleMin = Number(stackRoot?.dataset.middleMin || 0);
    var topMin = Number(stackRoot?.dataset.topMin || 0);
    var middleDiscount = Number(stackRoot?.dataset.middleDiscount || 0);
    var topDiscount = Number(stackRoot?.dataset.topDiscount || 0);
    var discount = itemCount >= topMin ? topDiscount : itemCount >= middleMin ? middleDiscount : 0;
    var stackFinalTotal = Math.max(0, originalTotal - Math.round(originalTotal * discount / 100));
    cart.total_price = stackFinalTotal;
    var local = localCartCurrency(cart);
    var signature = (cart.currency || '') + ':' + items.map(function (item) { return item.key + ':' + item.quantity + ':' + linePrice(item); }).join('|') + ':' + (local ? local.currency + ':' + local.rate + ':' + local.decimals : '');
    var first = matched[0];
    var existing = first.parentElement && first.parentElement.querySelector('[data-bracelet-stack-kaching-panel]');
    if (first.dataset.braceletStackKachingSignature === signature && existing) {
      var existingPrice = first.querySelector('.kaching-cart-item__total');
      if (existingPrice) {
        var existingFinalText = money(stackFinalTotal, local);
        var existingOriginalText = originalTotal > stackFinalTotal ? money(originalTotal, local) : '';
        existingPrice.innerHTML = existingOriginalText && existingOriginalText !== existingFinalText
          ? '<span class="kaching-cart-item__total-final">' + existingFinalText + '</span><s class="kaching-cart-item__total-old">' + existingOriginalText + '</s>'
          : existingFinalText;
      }
      document.querySelectorAll('.kaching-cart__checkout-button').forEach(function (button) {
        var label = button.querySelector('.kaching-cart__checkout-button-label b');
        if (!label) return;
        if (button.dataset.braceletStackKachingCheckout === undefined) button.dataset.braceletStackKachingCheckout = label.innerHTML;
        if (local) label.textContent = 'CHECKOUT • ' + money(cart.total_price, local);
      });
      return;
    }

    restoreKaching();
    document.querySelectorAll('.kaching-cart__checkout-button').forEach(function (button) {
      var label = button.querySelector('.kaching-cart__checkout-button-label b');
      if (!label) return;
      if (button.dataset.braceletStackKachingCheckout === undefined) button.dataset.braceletStackKachingCheckout = label.innerHTML;
      if (local) label.textContent = 'CHECKOUT • ' + money(cart.total_price, local);
    });
    matched = items.map(function (item) {
      return rowByProduct[String(item.product_id)] || rowByVariant[String(item.variant_id)];
    }).filter(Boolean);
    if (matched.length !== items.length) return;
    first = matched[0];
    var title = first.querySelector('.kaching-cart-item__title');
    var price = first.querySelector('.kaching-cart-item__total');
    if (!title || !price) return;
    first.dataset.braceletStackKachingTitle = title.innerHTML;
    first.dataset.braceletStackKachingPrice = price.innerHTML;
    first.dataset.braceletStackKachingSignature = signature;
    first.dataset.braceletStackKachingEnhanced = 'true';
    title.textContent = 'Build Your Own Bundle (up to 15%)';
    title.href = braceletStackUrl;
    var stackImage = first.querySelector('.kaching-cart-item__image');
    var stackImageLink = stackImage && stackImage.closest('a');
    if (stackImage) {
      first.dataset.braceletStackKachingImage = stackImage.getAttribute('src') || '';
      first.dataset.braceletStackKachingSrcset = stackImage.getAttribute('srcset') || '';
      stackImage.src = braceletStackImage;
      stackImage.removeAttribute('srcset');
      stackImage.alt = 'Bracelet Stack';
    }
    if (stackImageLink) {
      first.dataset.braceletStackKachingImageHref = stackImageLink.getAttribute('href') || '';
      stackImageLink.href = braceletStackUrl;
    }
    var finalTotal = stackFinalTotal;
    var finalText = money(finalTotal, local);
    var originalText = originalTotal > finalTotal ? money(originalTotal, local) : '';
    price.innerHTML = originalText && originalText !== finalText
      ? '<span class="kaching-cart-item__total-final">' + finalText + '</span><s class="kaching-cart-item__total-old">' + originalText + '</s>'
      : finalText;
    var remove = first.querySelector('.kaching-cart-item__remove-btn');
    if (remove) remove.setAttribute('data-bracelet-stack-kaching-remove', 'true');

    var panel = document.createElement('div');
    panel.className = 'bracelet-stack-kaching-panel';
    panel.setAttribute('data-bracelet-stack-kaching-panel', 'true');
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'bracelet-stack-kaching-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = '<span data-bracelet-stack-kaching-toggle-label>Show ' + items.length + ' items</span><span aria-hidden="true">&#x2304;</span>';
    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      toggleKachingPanel(toggle);
    });
    panel.appendChild(toggle);
    var children = document.createElement('div');
    children.className = 'bracelet-stack-kaching-items';
    children.setAttribute('data-bracelet-stack-kaching-items', 'true');
    children.hidden = true;
    items.forEach(function (item, index) {
      var child = document.createElement('div');
      child.className = 'bracelet-stack-kaching-item';
      var sourceLink = matched[index].querySelector('a[href*="/products/"]');
      var href = item.url || (sourceLink && sourceLink.getAttribute('href'));
      var content = href ? document.createElement('a') : child;
      if (href) {
        content.className = 'bracelet-stack-kaching-item-link';
        content.href = href;
      }
      var image = document.createElement('img');
      image.src = (item.featured_image && (item.featured_image.url || item.featured_image)) || item.image || '';
      image.alt = '';
      content.appendChild(image);
      var info = document.createElement('div');
      var name = document.createElement('div');
      name.textContent = String(item.quantity || 1) + ' x ' + item.product_title;
      info.appendChild(name);
      if (item.variant_title && item.variant_title !== 'Default Title') {
        var variant = document.createElement('div');
        variant.className = 'bracelet-stack-kaching-variant';
        variant.textContent = item.variant_title;
        info.appendChild(variant);
      }
      Object.keys(item.properties || {}).filter(function (key) { return key.charAt(0) !== '_'; }).forEach(function (key) {
        var property = document.createElement('div');
        property.className = 'bracelet-stack-kaching-variant';
        property.textContent = key + ': ' + item.properties[key];
        info.appendChild(property);
      });
      content.appendChild(info);
      if (href) child.appendChild(content);
      children.appendChild(child);
    });
    panel.appendChild(children);
    first.after(panel);

    matched.slice(1).forEach(function (row) {
      row.dataset.braceletStackKachingDisplay = row.style.display;
      row.style.display = 'none';
      row.setAttribute('aria-hidden', 'true');
      row.setAttribute('data-bracelet-stack-kaching-hidden', 'true');
    });
  }

  function syncKachingCart() {
    readKachingCart().then(groupKachingCart);
  }

  document.addEventListener('cart:updated', function (event) {
    if (!event.detail || !event.detail.cart) return;
    kachingRequestAt = 0;
    kachingRequest = null;
    window.setTimeout(syncKachingCart, 400);
  });

  document.addEventListener('bracelet-stack:cart-updated', function () {
    restoreKaching();
    kachingRequest = null;
    window.setTimeout(syncKachingCart, 400);
    window.setTimeout(function () {
      kachingRequest = null;
      syncKachingCart();
    }, 1500);
  });

  document.addEventListener('click', function (event) {
    var kachingRemove = event.target.closest('[data-bracelet-stack-kaching-remove]');
    if (kachingRemove) {
      event.preventDefault();
      event.stopImmediatePropagation();
      readKachingCart().then(function (cart) {
        if (!cart) return;
        var updates = {};
        cart.items.filter(function (item) { return item.properties && item.properties._bracelet_stack === 'true'; }).forEach(function (item) { updates[item.key] = 0; });
        return fetch(cartRoot() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      }).then(function () { window.location.reload(); });
      return;
    }

    var toggle = event.target.closest('[data-bracelet-stack-toggle]');
    if (toggle) {
      var items = toggle.parentElement.querySelector('[data-bracelet-stack-items]');
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      items.hidden = expanded;
      toggle.querySelector('[data-bracelet-stack-toggle-label]').textContent = (expanded ? 'Show ' : 'Hide ') + items.children.length + ' items';
      return;
    }

    var remove = event.target.closest('[data-bracelet-stack-remove]');
    if (!remove) return;
    var group = remove.closest('[data-bracelet-stack-panel]');
    var root = group && group.closest('cart-drawer, cart-items');
    var updates = {};
    document.querySelectorAll('[data-bracelet-stack-line="true"]').forEach(function (row) { updates[row.dataset.lineKey] = 0; });
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    }).then(function (response) { return response.json(); }).then(function (data) {
      if (root && root.tagName === 'CART-DRAWER' && typeof root.renderContents === 'function' && data.sections) root.renderContents(data);
      else window.location.reload();
    });
  }, true);

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () { scheduled = false; groupRows(); syncKachingCart(); }, 0);
  }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', groupRows);
  document.addEventListener('DOMContentLoaded', syncKachingCart);
  schedule();
})();
